define('views/productgroup/index',[],function() {
	'use strict';

	window.assets = window.assets || {};

	require(['classes/responsivebanner'], function(ResponsiveBanner) {
		var banners = document.querySelectorAll('.header-banner'),
			i;
		for (i = 0; i < banners.length; ++i) {
			new ResponsiveBanner({
				banner: banners[i]
			});
		}
	});

	require(['classes/filters'], function(filters) {
		window.assets.filters = filters;
		window.assets.filters.initiate(function() {
			console.log('filters initiated the old way');
		});
	});

	require(['classes/product', 'postal'], function(Product, postal) {
		// catch all products
		var products = document.querySelectorAll('#items .item'),
			i;
		for (i = 0; i < products.length; ++i) {
			new Product({
				element: products[i]
			}).initiate();
		}

		postal.channel('page').subscribe({
			topic: 'new.products',
			callback: function(data) {
				var products = data.batch.querySelectorAll('.item'),
					i;
				for (i = 0; i < products.length; ++i) {
					new Product({
						element: products[i]
					}).initiate();
				}

			}
		});
	});

	require(['classes/lazyload'], function(LazyLoad) {
	    window.assets.lazyload = new LazyLoad().initiate();
	});
 

	require(['classes/productgrid', 'classes/productgroupfilter'],
	function (ProductGrid, ProductGroupfilter) {
		var productGrids = document.querySelectorAll('#items'),
			loadMore     = document.querySelector('.load-more'),
			i;
		for (i = 0; i < productGrids.length; ++i) {
			new ProductGrid({
				element: productGrids[i],
				elementLoadMore: loadMore,
				filterClass: new ProductGroupfilter({}).initiate(),
				lazyLoad: window.assets.lazyload
			}).initiate();
		}
	});



	require(['classes/lookcarousel'], function(LookCarousel) {
		var lookCarousels = document.querySelectorAll('.look-swiper'),
			i;
		for (i = 0; i < lookCarousels.length; ++i) {
			new LookCarousel({
				element: lookCarousels[i],
				lazyLoad: window.assets.lazyload
			}).initiate();
		}
	});

	require(['classes/shorttext'], function(ShortText) {
		var texts = document.querySelectorAll('#short-about-text'),
			i;
			console.log('load')
		for (i = 0; i < texts.length; ++i) {
			new ShortText({
				text: texts[i]
			});
		}
	});

	require(['classes/recommendation', 'postal'], function(Recommendation, postal) {
		var recommendations = document.querySelectorAll('.recommendations'),
			i,
			recommendationsObjects = [];
		for (i = 0; i < recommendations.length; ++i) {
			recommendationsObjects.push(new Recommendation({
				element: recommendations[i],
				type: recommendations[i].getAttribute('data-recommendation-type')
			}).initiate());
		}

		var isRecommendationsReady = function() {
			for (i = 0; i < recommendations.length; ++i) {
				if (!recommendationsObjects[i].ready) {
					return false;
				}
			}

			clearInterval(waitForAllRecommendations);

			return true;
		};

		var waitForAllRecommendations = setInterval(function() {
			if (isRecommendationsReady()) {
				postal.channel('nosto').publish({
					topic: 'recommendation.all',
					data: function() {
						postal.channel('recommendation').publish({
							topic: 'render'
						});
					}
				});
			}
		}, 200);
	});

	

});
